import { Typography } from '@mui/material'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import TabPanel from '../../../../../shared/components/TabPanel'
import { BtnLinkDetail, ContainerDetail, TalkerDateDetail } from '../../../../../shared/styles/SeminarGlobalStyles'
import UserTable from '../../pages/RegisteredUsersTable'
import SeminarLessonBlock from '../SeminarLessonBlock'
import SeminarLessonModal from '../SeminarLessonModal'

dayjs.extend(localizedFormat)
dayjs.locale('es')

interface ContentTabsProps {
  currentTab: number
  seminarSelected: any
  seminarlesson_selected: any
  showFormSeminarLesson: boolean
  registeredUsers: any[]
  hasUserAccess: boolean
  onOpenTicketModal: () => void
  tableColumns: any[]
  authUser: any
  t: (key: string) => string
}

const ContentTabs = ({
  currentTab,
  seminarSelected,
  seminarlesson_selected,
  showFormSeminarLesson,
  registeredUsers,
  hasUserAccess,
  onOpenTicketModal,
  tableColumns,
  t
}: ContentTabsProps) => {
  const renderLessonDetail = () => (
    <ContainerDetail>
      <Typography align="center" variant="h4">
        {t('about-this-event')}
      </Typography>
      <Typography>{seminarSelected.description}</Typography>
      {seminarlesson_selected.datetime && (
        <TalkerDateDetail>
          <Typography>{dayjs(seminarlesson_selected.datetime).format('LLLL')}</Typography>
        </TalkerDateDetail>
      )}

      {seminarlesson_selected.isRegistered === null && (
        <BtnLinkDetail variant="contained" color="primary" onClick={onOpenTicketModal}>
          {t('book-my-ticket')}
        </BtnLinkDetail>
      )}
    </ContainerDetail>
  )

  const renderLessonsList = () => (
    <>
      {showFormSeminarLesson && <SeminarLessonModal />}
      {seminarSelected.lessons.map((seminarlesson: any) => (
        <SeminarLessonBlock
          key={seminarlesson.id}
          seminarlesson={seminarlesson}
          vipContent={seminarSelected.visibility === 1}
          hasaccess={hasUserAccess}
        />
      ))}
    </>
  )

  return (
    <>
      <TabPanel data-testid="tab-content-expanded" value={currentTab} index={0}>
        {seminarlesson_selected !== null && showFormSeminarLesson === false ? renderLessonDetail() : renderLessonsList()}
      </TabPanel>

      <TabPanel data-testid="tab-registered-expanded" value={currentTab} index={1}>
        <div className="table_custom">
          <UserTable title="Seminarios Admin" columns={tableColumns} data={registeredUsers} />
        </div>
      </TabPanel>
    </>
  )
}

export default ContentTabs
